/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cover-container[_ngcontent-%COMP%]{max-width:1150px;width:100%;margin:0 auto}.cover-box[_ngcontent-%COMP%]{margin-top:200px;display:flex;justify-content:flex-start;align-items:flex-start}.approval-letter[_ngcontent-%COMP%]{max-height:450px;height:100%}"];
export { styles as styles };
